import Input from 'components/common/form/input/Input';
import { Form, Formik } from 'formik';
import React from 'react';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { AddressFormValues, Props } from './studentAddressForm.type';
import Select from 'components/common/form/select/Select';
import { countryOptions } from 'pages/profile/edit/form/candidateProfile/form/CandidateBasicForm/config';

function StudentAddressForm({ innerRef, data, isReadOnly }: Props) {
  const handleSubmit = (values: AddressFormValues) => {
    return Promise.resolve(values);
  };
  return (
    <Formik
      innerRef={innerRef}
      initialValues={{
        street: data?.info?.address?.street ?? '',
        city: data?.info?.address?.city ?? '',
        state: data?.info?.address?.state ?? '',
        postalCode: data?.info?.address?.postalCode ?? '',
        country: data?.info?.address?.country ?? ''
      }}
      onSubmit={handleSubmit}
    >
      <Form>
        <Row className="g-5">
          <Col xs={12} xl={4}>
            <FormGroup className="text-start">
              <FormLabel htmlFor="street">Street</FormLabel>
              <Input name="street" id="street" disabled={isReadOnly} />
            </FormGroup>
          </Col>
          <Col xs={12} xl={4}>
            <FormGroup className="text-start">
              <FormLabel htmlFor="city">City</FormLabel>
              <Input name="city" id="city" disabled={isReadOnly} />
            </FormGroup>
          </Col>
          <Col xs={12} xl={4}>
            <FormGroup className="text-start">
              <FormLabel htmlFor="state">State</FormLabel>
              <Input name="state" id="state" disabled={isReadOnly} />
            </FormGroup>
          </Col>
          <Col xs={12} xl={4}>
            <FormGroup className="text-start">
              <FormLabel htmlFor="postalCode">Postal Code</FormLabel>
              <Input name="postalCode" id="postalCode" disabled={isReadOnly} />
            </FormGroup>
          </Col>
          <Col xs={12} xl={4}>
            <FormGroup className="text-start">
              <FormLabel htmlFor="country">Country</FormLabel>
              <Select
                name="country"
                id="country"
                disabled={isReadOnly}
                options={countryOptions}
              />
            </FormGroup>
          </Col>
        </Row>
      </Form>
    </Formik>
  );
}

export default StudentAddressForm;
